// extracted by mini-css-extract-plugin
export default {"footer":"vp_npEoZ"};